import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IdentityService } from 'app/services/authentication/identity.service';
import { CookieService } from 'ngx-cookie-service';

@Injectable({ providedIn: 'root' })
export class LanguageService {

  public languages: string[] = ['en-us', 'es-ar'];

  constructor(public translate: TranslateService, private cookieService: CookieService, private _identityService: IdentityService) {

    let browserLang: any;
    /***
     * cookie Language Get
    */
    this.translate.addLangs(this.languages);
    if (this.cookieService.check('lang')) {
      browserLang = this.cookieService.get('lang');
    }
    else {
      browserLang = translate.getBrowserLang();
    }
    // Map short browser codes to full locale codes (e.g. "en" → "en-us", "es" → "es-ar")
    let langToUse = 'en-us';
    if (browserLang) {
      if (this.languages.includes(browserLang)) {
        langToUse = browserLang;
      } else if (browserLang.match(/^es/)) {
        langToUse = 'es-ar';
      }
    }
    translate.use(langToUse);
  }

  /***
   * Cookie Language set
   */
  public setLanguage(lang: any) {
    this.translate.use(lang);
    this.cookieService.set('lang', lang);
  }

  setLanguageByBrowser() {
    console.log('Setting language based on browser preferences...');
    const browserLang = this.translate.getBrowserLang() == 'es' ? 'es-ar' : 'en-us';
    const languageToSet = this.languages.includes(browserLang) ? browserLang : 'en-us'; // Asegúrate de que el idioma esté en la lista de idiomas soportados
    this.translate.use(languageToSet);
    this.cookieService.set('lang', languageToSet); // Guarda el idioma en las cookies para futuras referencias
    this._identityService.defaultLanguage = languageToSet;
    console.log('Language set to:', languageToSet);
  }

}
